<template>
  <div class="user">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Company</span>
          </div>
          <div>
            <table>
              <tr>
                <th>Company :</th>
                <td>{{ userData.companyname }}</td>
              </tr>
              <tr>
                <th>Member Code :</th>
                <td>{{ userData.membercode }}</td>
              </tr>
              <tr>
                <th>Username :</th>
                <td>{{ userData.fullname }}</td>
              </tr>
              <tr>
                <th>Email :</th>
                <td>{{ userData.email }}</td>
              </tr>
            </table>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Change Password</span>
          </div>
          <div>
            <el-form
              :model="ruleForm"
              status-icon
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
            >
              <el-form-item label="Current Password" prop="current">
                <el-input type="password" v-model="ruleForm.current" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="New Password" prop="pass">
                <password v-model="ruleForm.pass" autocomplete="off"></password>
              </el-form-item>
              <el-form-item label="Confirm Password" prop="checkPass">
                <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm()">Submit</el-button>
                <el-button @click="resetForm()">Reset</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Password from "vue-password-strength-meter";
import user from "@/api/user";
export default {
  components: { Password },
  data() {
    var checkCurrent = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the current password"));
      } else {
        setTimeout(() => {
          if (this.ruleForm.current !== "") {
            this.$refs.ruleForm.validateField("current");
          }
          callback();
        }, 400);
      }
    };

    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    return {
      userData: {
        companyname: "",
        membercode: "",
        user: ""
      },
      ruleForm: {
        pass: "",
        checkPass: "",
        current: ""
      },
      rules: {
        current: [{ validator: checkCurrent, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  methods: {
    getUser() {
      user.getUser().then(res => {
        if (res && res["result"]) {
          this.userData = res["data"];
          this.$store.state.user = res["data"];
        }
      });
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const formData = {
            newpassword: this.ruleForm.pass,
            currentpassword: this.ruleForm.current
          };

          user.updateUser(formData).then(res => {
            if (res && res["result"]) {
              this.$message({
                message: "Congrats, Change password is success.",
                type: "success"
              });
            } else {
              this.$message.error(res["message"]);
            }
          });
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    }
  },
  created() {
    this.getUser();
  }
};
</script>

<style lang="scss">
.user {
  table {
    width: 100%;
    th {
      width: 50%;
      text-align: right;
      padding-right: 30px;
    }
  }

  .Password {
    max-width: unset;
    margin: 0;
}

  .Password__field {
    background-color: #ffffff;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    box-sizing: border-box;
    font-size: 14px;
    padding: 13px;
    width: 100%;
  }

  .Password__field:focus {
    border: 1px solid #dcdfe6;
  }
}
</style>